import { DeploymentRing } from '@fluidx/office-fluid-types';
import { getOrFetchOdspDriverManifest } from './OdspDriverManifestAccessors';
import { OdspDriverManifest, currentVersionKey } from './OdspDriverManifestType';

export async function getBundleUrlForEnvironment(environment?: DeploymentRing): Promise<string> {
  const manifest = await getOrFetchOdspDriverManifest(environment);
  return getBundleUrlFromManifest(manifest);
}

export function getBundleUrlFromManifest(manifest: OdspDriverManifest): string {
  return manifest.jsBaseUrl + '/' + manifest[currentVersionKey].index;
}
